






















import { Component, Model, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class CFormInput extends Vue {
    @Prop()
    name!: string;

    @Prop({
        default: 'text'
    })
    type!: string;

    @Prop({
        default: ''
    })
    variant!: string;

    @Prop({
        default: ''
    })
    placeholder!: string;

    @Prop({
        default: false
    })
    disabled!: boolean;

    @Prop({
        default: null
    })
    valueMetric!: string | null;

    @Model('input', { type: [String, Number] })
    readonly value!: string;

    $refs!: {
        input: HTMLInputElement;
    };

    get formattedValue() {
        return parseInt(this.value);
    }

    get actualInputValue() {
        return this.valueMetric ? this.formattedValue : this.value;
    }

    inputValue(e: any) {
        if (e && e.target && e.target.value) {
            let value = e.target.value;
            if (this.name === '--avatar-border-radius' && value > 512) {
                value = 512;
                this.$refs.input.value = value;
            }
            if (this.valueMetric) {
                this.$emit('input', `${value}${this.valueMetric}`);
            } else {
                this.$emit('input', value);
            }
        }
    }
}
